module.exports = __webpack_public_path__ + "static/media/mascot03.3b367b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/mascot03.png
// module id = 180
// module chunks = 0